import { CachedStore } from "@fry-it/risr-core";
import { Injectable } from "@angular/core";
import { RelationApiResponse, Relation } from "./relation";

@Injectable({
    providedIn: 'root'
})
export class RelationStore extends CachedStore<RelationApiResponse, Relation> {
    prefix = 'relations';

    public async getAll(): Promise<Relation[]> {
        const relations = await this.fetchAll();
        return relations.map(this.fromApiResponse);
    }

    protected fetchOne(key: string): Promise<RelationApiResponse> {
        return this.api.get<RelationApiResponse>(`/relations/${key}`);
    }

    protected fetchAll(): Promise<RelationApiResponse[]> {
        return this.api.get<RelationApiResponse[]>(`/relations/`);
    }

    protected fromApiResponse(response: RelationApiResponse): Relation {
        return Relation.fromApiResponse(response);
    }
}